var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-promotion-coupon',{ref:"table",staticClass:"pt-promotion-coupon__withData",on:{"deleteCoupon":_vm.deleteCoupon,"couponStatus":_vm.couponStatus,"promotionDelete":_vm.promotionDelete,"promotionStatus":_vm.promotionStatus}})}
var staticRenderFns = []

export { render, staticRenderFns }